import React from 'react'
import styled from '@emotion/styled'
import { Button } from '@mobi/component-library/Base/Buttons/Button'
import { spacing } from '@mobi/component-library/Foundations'
import { Ticket } from '@core/Areas/Account/Pages/Activity/types'
import { RaceNotificationButton } from '@core/Areas/Racing/Components/RaceNotificationButton'
import { TicketLayoutType } from '../../helpers'

export const RaceAlertButton: React.FC<{
  ticket: Ticket
  ticketLayoutType: TicketLayoutType
}> = ({ ticket, ticketLayoutType }) => {
  const leg = ticket.legs[0]

  const isSingleRace =
    ticketLayoutType === 'single-single' ||
    ticketLayoutType === 'single-multiple' ||
    ticketLayoutType === 'same-race-multi'

  const canSetAlert =
    isSingleRace && leg.meetingName && leg.raceNumber && leg.fixtureDate && leg.fixtureId

  if (!canSetAlert) {
    return null
  }

  return (
    <span data-testid='ticket-footer-alert-button'>
      <RaceNotificationButton
        raceStatus='Pending'
        raceTime={new Date(leg.advertisedStartTime)}
        meetingName={leg.meetingName}
        raceNumber={leg.raceNumber}
        meetingDate={leg.fixtureDate}
        meetingId={leg.fixtureId}
        buttonComponent={ButtonComponent}
      />
    </span>
  )
}

// ===============
// Local Component
// ===============

const ButtonComponent: React.FC<React.HTMLAttributes<HTMLButtonElement>> = ({
  onClick,
  children,
  ...attributes
}) => (
  <ButtonStyled
    // @ts-expect-error Prop name clashes with attribute
    color='tertiary_grey'
    size='xs'
    onClick={onClick}
    {...attributes}
  >
    {children} Alert
  </ButtonStyled>
)

// ======
// Styles
// ======

const ButtonStyled = styled(Button)({
  padding: `${spacing.smx1} ${spacing.smx2}`,
  gap: spacing.smx2,
})
